import appManagerNav from './navigation_modules/appManager';
import customerNav from './navigation_modules/customer';
import dashboardNav from './navigation_modules/dashboard';
import cryptoNav from './navigation_modules/crypto';
import settingNav from './navigation_modules/settings';
import transactionNav from './navigation_modules/transaction';
import workforceNav from './navigation_modules/workforce';
import giftcardNav from './navigation_modules/giftcard';
import rewardsNav from './navigation_modules/rewards';

const Navigations = [
    ...dashboardNav,
    ...customerNav,
    ...cryptoNav,
    ...giftcardNav,
    ...transactionNav,
    ...appManagerNav,
    ...rewardsNav,
    ...workforceNav,
    ...settingNav,
];

export default Navigations; 